import { CONTENT_GROUP_DUPLICATE } from "../constants";

const initialState = {
    loading: false,
    error: null,
    isModalOpen: false,
    workspace_id: null,
    stage_id: null,
    content_group_id: null,
    escapeable: true,
    boundary: null,
    stages: [],
};

export const card_duplicate = (state = initialState, action) => {
    switch (action.type) {
        case CONTENT_GROUP_DUPLICATE.OPEN_DUPLICATE_MODAL:
            const escapeable = action.payload?.escapeable || true;
            
            return {
                ...state,
                isModalOpen: true,
                content_group_id: action.payload.content_group_id,
                workspace_id: action.payload.workspace_id,
                stage_id: action.payload.stage_id,
                boundary: action.payload.boundary,
                escapeable: escapeable
            };
        case CONTENT_GROUP_DUPLICATE.CLOSE_DUPLICATE_MODAL:
            return {
                ...state,
                isModalOpen: false,
                content_group_id: null,
                stage_id: null,
                workspace_id: null,
                boundary: null,
                stages: []
            };
        case CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_LOADING:
            return{
                ...state,
                loading: true,
                error: null
            }
        case CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_SET_STAGES:
            return {
                ...state,
                stages: action.payload
            }
        case CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case CONTENT_GROUP_DUPLICATE.CARD_DUPLICATE_RESET:
            return initialState;
        default:
            return state;
    }
};
